/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'book-arrow-left-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 012-2h12a2 2 0 012 2v9.09c-.33-.05-.66-.09-1-.09-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M18 18v-2l-3 3 3 3v-2h4v-2h-4z"/>'
  }
})
